/**
 * 日期转字符串
 * @param date
 * @param format
 * @returns {*}
 */
export function dateToString(date, format) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    let string = format.replace('yyyy', year)
    string = string.replace('MM', month)
    string = string.replace('dd', day)
    return string
}
//月份1-9月 变为 01-09
export function dateToStringM(date,format) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    let string = format.replace('yyyy', year)
    if (month < 10) {
        string = string.replace('MM', '0'+month);
    } else {
        string = string.replace('MM', month);
    }
    string = string.replace('dd', day)
    return string

}